var map = {
	"./app_download.svg": "59d8",
	"./apple.svg": "f9d5",
	"./arrow_right.svg": "e45f",
	"./bag.svg": "47fd",
	"./bottom_arrow.svg": "f66c",
	"./closed.svg": "99b0",
	"./consume.svg": "9602",
	"./copy_link.svg": "ac6f",
	"./copy_link_blue.svg": "d1bf",
	"./delete.svg": "0d45",
	"./down_arrow.svg": "d005",
	"./download.svg": "f28e",
	"./editor.svg": "4943",
	"./editor_big.svg": "4bf9",
	"./finger.svg": "da05",
	"./key.svg": "daf4",
	"./miniprogram.svg": "8b63",
	"./mp3.svg": "4c98",
	"./music_bg.svg": "9081",
	"./pause.svg": "644b",
	"./play.svg": "dab1",
	"./quit.svg": "c827",
	"./remind.svg": "e282",
	"./save.svg": "9344",
	"./service.svg": "df0e",
	"./stop.svg": "56b4",
	"./success.svg": "1c27",
	"./template.svg": "909f",
	"./triangle.svg": "a8fe",
	"./upload.svg": "5a96",
	"./wallet.svg": "4f4a",
	"./wallet_color.svg": "97e8",
	"./yin.svg": "475a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";